'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _VirtualizedSelect = require('./VirtualizedSelect');

var _VirtualizedSelect2 = _interopRequireDefault(_VirtualizedSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VirtualizedSelect2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized-select/dist/commonjs/VirtualizedSelect/index.js
// module id = 1817
// module chunks = 1